import { useState } from "react";
import { fillTemplate } from "../../../guidePage.util";
import type { RepeatPlanCopy } from "../repeatPlanBuilder.component";

// Up to `maxActions` ticked actions become a four-week plan: each week lists
// that week's task for every ticked action, with the guide's fixed first-
// and last-week reminders around them.
export function useRepeatPlan(copy: RepeatPlanCopy) {
  const initialState = { selected: [] as string[] };
  const [state, setState] = useState(initialState);

  const toggle = (key: string) =>
    setState((state) => {
      const isOn = state.selected.includes(key);
      if (!isOn && state.selected.length >= copy.maxActions) return state;
      return {
        ...state,
        selected: isOn
          ? state.selected.filter((item) => item !== key)
          : [...state.selected, key],
      };
    });

  // Keep the options' order, not the order they were ticked in.
  const actions = copy.actions.filter((action) =>
    state.selected.includes(action.key),
  );
  const weeks = copy.weeks.map((week, index) => ({
    label: week.label,
    items: [
      ...(week.lead ? [week.lead] : []),
      ...actions.map((action) => action.weeks[index]),
    ],
  }));
  const isFull = state.selected.length >= copy.maxActions;

  const planText = actions.length
    ? `${fillTemplate(copy.copyTitle, {
        actions: actions.map((action) => action.label).join(", "),
      })}\n\n${weeks
        .map((week) => `${week.label}:\n- ${week.items.join("\n- ")}`)
        .join("\n\n")}`
    : "";

  return {
    selected: state.selected,
    toggle,
    isFull,
    hasPlan: actions.length > 0,
    weeks,
    planText,
  };
}
